import { render, staticRenderFns } from "./ProductDeposits.vue?vue&type=template&id=e4daa64c&scoped=true&"
import script from "./ProductDeposits.vue?vue&type=script&lang=ts&"
export * from "./ProductDeposits.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDeposits.vue?vue&type=style&index=0&id=e4daa64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4daa64c",
  null
  
)

export default component.exports